var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-input',{attrs:{"type":"textarea","rows":3,"placeholder":_vm.placeholder},on:{"input":_vm.input},model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}})
}
var staticRenderFns = []

export { render, staticRenderFns }